import { render, staticRenderFns } from "./VMapLegendEez.vue?vue&type=template&id=e2849456&"
import script from "./VMapLegendEez.vue?vue&type=script&lang=js&"
export * from "./VMapLegendEez.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports